<template>
  <div>
    <Head title="Create Company" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-blue-400 hover:text-blue-600" href="/companies">Companies</Link>
      <span class="text-blue-400 font-medium">/</span> Create
    </h1>
    <div class="max-w-3xl bg-white  shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <select-input v-model="form.region_id" :error="form.errors.region_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Region">
            <option v-for="region in regions" :key="region.id" :value="region.id"> {{ region.name }}</option>
          </select-input>
          <select-input v-model="form.price_list_id" :error="form.errors.price_list_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Price List">
            <option v-for="pricelist in pricelists" :key="pricelist.id" :value="pricelist.id"> {{ pricelist.name }}</option>
          </select-input>
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-blue" type="submit">Create Company</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  remember: 'form',
  props: {
    regions: Array,
    pricelists : Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        name         : null,
        region_id    : null,
        price_list_id: null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/companies')
    },
  },
}
</script>
